import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiLibraryModule } from "../ui-library/ui-library.module";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { NavigationComponent } from "./navigation/navigation.component";

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    NavigationComponent,
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    UiLibraryModule,
  ],
})
export class PartialsModule { }



// WEBPACK FOOTER //
// ./src/app/partials/partials.module.ts